export default "__VITE_ASSET__CvNlxLo5__"